<template>
  <div id="faz-corona-dashboard" :class="{ small: isSmall }" ref="app" v-if="!loading">
    <div class="header">
      <div class="date">Zuletzt aktualisiert heute, {{incidence.date.slice(12)}}</div>
      <div class="headline">Das Coronavirus in Deutschland</div>
      <div class="search">
        <div class="regionSelect">
          <multiselect 
            v-model="selectedRegion" 
            :options="selectOptions" 
            :show-labels="false" 
            placeholder="Landkreis / Stadt suchen"
            track-by="OBJECTID" 
            label="GEN">
          </multiselect>
            <!-- @select="select" -->
        </div>
        <!-- <div class="search_placeholder">Landkreis/kreisfreie Stadt suchen</div> -->
      </div>
    </div>
    <div class="content">
      <div class="content_element" :class="{ active: accordion[0] }" @click="toggleAccordion(0)">
        <div class="headlines">
          <div class="headline">Neuinfektionen</div>
          <div class="subheadline">pro 100.000 Einwohner in den letzten sieben Tagen</div>
        </div>
        <div class="map">
          <ChoroplethMap
            :data="incidence.map"
            :geoJson="landkreiseMap"
            :geoJsonSupraregional="blMap"
            v-model="selectedLkID"
            :options="{
              zoom:false, 
              regionKey:'OBJECTID',
              regionLabel:'GEN',
              type:'heatmap',
              colorScale: colors[0],
              legendPosition:'right'
            }"
          />
        </div>
        <div v-if="showToolbox">
          <input v-model="colors[0][0]">
          <input v-model="colors[0][1]">
        </div>
        <div class="divider"></div>
        <div class="twoCols">
          <div>
            <div class="indicator orange">{{incidenceComp}}</div>
            <div class="indicatorLabel">7-Tage-Inzidenz</div>
            <div class="change" v-if="selectedRegion">{{selectedRegion.GEN}}</div>
            <div class="change" v-else><span class="number orange">{{incidence.diff}}</span> zur Vorwoche</div>
          </div>
          <div class="chart" v-if="!selectedRegion">
            <LineChart
              :data="incidence.chart"
              :options="{
                grid:false, 
                height:67, 
                colors: ['#ED7D38'],
                tooltip: false,
                dot: true,
                fontSize: 13,
                lineWidth: 2
              }"
            />
          </div>
        </div>
        <!-- <div class="stat"><span class="number orange">+190.148</span> Neuinfektionen gestern</div> -->
      </div>
      <div class="content_element" :class="{ active: accordion[1] }" @click="toggleAccordion(1)">
        <div class="headlines">
          <div class="headline">Hopspitalisierungen</div>
          <div class="subheadline">pro 100.000 Einwohner in den letzten sieben Tagen</div>
        </div>
        <div class="map">
          <ChoroplethMap
            :data="hospitalizations.map"
            :geoJson="blMap2"
            :geoJsonSupraregional="blMap"
            v-model="selectedBlID"
            :options="{
              zoom:false, 
              regionKey:'ID_1',
              regionLabel:'NAME_1',
              type:'heatmap',
              colorScale: colors[1],
              legendPosition:'right'
            }"
          />
        </div>
        <div v-if="showToolbox">
          <input v-model="colors[1][0]">
          <input v-model="colors[1][1]">
        </div>
        <div class="divider"></div>
        <div class="twoCols">
          <div>
            <div class="indicator blue">{{hospComp}}</div>
            <div class="indicatorLabel">Hospitalisierungsinzidenz</div>
            <div class="change" v-if="selectedRegion">{{selectedBL}}</div>
            <div class="change" v-else><span class="number blue">{{hospitalizations.diff}}</span> zur Vorwoche</div>
          </div>
          <div class="chart" v-if="!selectedRegion">
            <LineChart
              :data="hospitalizations.chart"
              :options="{
                grid:false, 
                height:67, 
                colors: ['#577BB7'],
                tooltip: false,
                dot: true,
                fontSize: 13,
                lineWidth: 2
              }"
            />
          </div>
        </div>
        <!-- <div class="stat"><span class="number blue">+2345</span> Klinikaufnahmen in den letzten sieben Tagen</div> -->
      </div>
      <div class="content_element" :class="{ active: accordion[2] }" @click="toggleAccordion(2)">
        <div class="headlines">
          <div class="headline">Todesfälle</div>
          <div class="subheadline">pro 100.000 Einwohner, seit Pandemiebeginn</div>
        </div>
        <div class="map">
          <ChoroplethMap
            :data="deaths.map"
            :geoJson="landkreiseMap"
            :geoJsonSupraregional="blMap"
            v-model="selectedLkID"
            :options="{
              zoom:false, 
              regionKey:'OBJECTID',
              regionLabel:'GEN',
              type:'heatmap', 
              colorScale: colors[2],
              legendPosition:'right'
            }"
          />
        </div>
        <div v-if="showToolbox">
          <input v-model="colors[2][0]">
          <input v-model="colors[2][1]">
        </div>
        <div class="divider"></div>
        <div class="twoCols">
          <div>
            <div class="indicator red">{{deathsComp}}</div>
            <div class="indicatorLabel">Todesfälle, 7-Tage-Mittelwert</div>
            <div class="change" v-if="selectedRegion">{{selectedRegion.GEN}}</div>
            <div class="change" v-else><span class="number red">{{deaths.diff}}</span> zur Vorwoche</div>
          </div>
          <div class="chart" v-if="!selectedRegion">
            <LineChart
              :data="deaths.chart"
              :options="{
                grid:false, 
                height:67, 
                colors: ['#b2002f'],
                tooltip: false,
                dot: true,
                fontSize: 13,
                lineWidth: 2
              }"
            />
          </div>
        </div>
        <!-- <div class="stat"><span class="number red">+190</span> Todesfälle gestern</div> -->
      </div>
      <div class="content_element" :class="{ active: accordion[3] }" @click="toggleAccordion(3)">
        <div class="headlines">
          <div class="headline">Impfungen</div>
          <div class="subheadline">Anteil der dreifach Geimpften</div>
        </div>
        <div class="map">
          <ChoroplethMap
            :data="vaccinations.map"
            :geoJson="blMap2"
            :geoJsonSupraregional="blMap"
            v-model="selectedBlID"
            :options="{
              zoom:false, 
              regionKey:'ID_1',
              regionLabel:'NAME_1',
              type:'heatmap',
              colorScale: colors[3],
              suffix:'%',
              domain:[40,70],
              legendPosition:'right'
            }"
          />
            <!-- :data="incidenceMap"
            :settings='{"title":"Stärkste Partei","type":"category","regionKey":"WKR_NR","colors":[{"label":"SPD","id":"SPD","color":"#c51d1e"},{"label":"CDU","id":"CDU","color":"#333"},{"label":"CSU","id":"CSU","color":"#333"},{"label":"Grüne","id":"GRÜNE","color":"#0c9941"},{"label":"FDP","id":"FDP","color":"#f6c909"},{"label":"AfD","id":"AfD","color":"#2b7ab4"},{"label":"Linke","id":"DIE LINKE","color":"#bb4894"},{"label":"Die PARTEI","id":"Die PARTEI","color":"#B92837"},{"label":"FW","id":"FREIE WÄHLER","color":"#b5b9bc"},{"label":"Piraten","id":"PIRATEN","color":"#f39200"},{"label":"REP","id":"REP","color":"#a07e26"},{"label":"NPD","id":"NPD","color":"#a07e26"},{"label":"Einheit","id":"EINHEIT","color":"#a284c7"},{"label":"Volt","id":"Volt","color":"#502379"},{"label":"Humanisten","id":"HUMANISTEN","color":"#d90368"},{"label":"DKP","id":"DKP","color":"red"}],"suffix":"%","legend":false}' -->
        </div>
        <div v-if="showToolbox">
          <input v-model="colors[3][0]">
          <input v-model="colors[3][1]">
        </div>
        <div class="divider"></div>
        <div class="twoCols">
          <div>
            <div class="indicator green">{{vaccsComp}}</div>
            <div class="indicatorLabel">Impfdosen, 7-Tage-Mittelwert</div>
            <div class="change" v-if="selectedRegion">{{selectedBL}}</div>
            <div class="change" v-else><span class="number green">{{vaccinations.diff}}</span> zur Vorwoche</div>
          </div>
          <div class="chart" v-if="!selectedRegion">
            <LineChart
              :data="vaccinations.chart"
              :options="{
                grid:false, 
                height:67, 
                colors:['#6FA746'],
                tooltip: false,
                dot: true,
                fontSize: 13,
                lineWidth: 2
              }"
            />
          </div>
        </div>
        <!-- <div class="stat">davon <span class="number green">75%</span> Booster-Impfungen</div> -->
      </div>
    </div>
    
    <div class="redirectButton" onclick="location.href='https://www.faz.net/1.6653240';">Alle Zahlen zur Pandemie</div>

    <!-- <p class="subheadline">Stand: </p> -->
    <!-- <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="grid-y">
          <div class="cell overlineBox">
            <div class="grid-x">
              <div class="cell small-6">
                <div class="headline">
                  7-Tage-Inzidenz
                </div>
                <div class="number" style="color:#ED7D38">{{ String(incidence.slice(-1)[0][1]).replace('.',',') }}</div>
                <div class="subheadline">
                  Neue Fälle pro 100.000 Einwohner in den letzten sieben Tagen
                </div>
              </div>
            </div>
            <div class="chart">
              <GChart
                class="gchart"
                type="AreaChart"
                :settings="{ packages: ['corechart'], language: 'de' }"
                :data="incidence"
                :options="chartOptions1"
              />
              <div class="date left">{{ incidence.slice(1)[0][0] }} </div>
              <div class="date right">{{ incidence.slice(-1)[0][0] }} </div>
            </div>
          </div>
          <div class="cell overlineBox">
            <div class="grid-x">
              <div class="cell small-6">
                <div class="headline">
                  Belegte Intensivbetten
                </div>
                <div class="number" style="color:#D13D3D">{{ intensive_care_beds.slice(-1)[0][1] }}</div>
                <div class="subheadline">
                  Covid-Patienten in Intensivbehandlung
                </div>
              </div>
            </div>
            <div class="chart">
              <GChart
                class="gchart"
                type="AreaChart"
                :settings="{ packages: ['corechart'], language: 'de' }"
                :data="intensive_care_beds"
                :options="chartOptions2"
              />
              <div class="date left">{{ intensive_care_beds.slice(1)[0][0] }} </div>
              <div class="date right">{{ intensive_care_beds.slice(-1)[0][0] }} </div>
            </div>
          </div>
          <div class="cell overlineBox">
            <div class="grid-x">
              <div class="cell small-6">
                <div class="headline">Impfquote</div>
                <div class="number" style="color:#0C9941">{{ String(Math.round(vaccinations.slice(-1)[0][2]*10)/10).replace('.',',') }}%</div>
                <div class="subheadline">
                  Anteil der vollständig Geimpften
                </div>
              </div>
            </div>
            <div class="chart">
              <GChart
                class="gchart"
                type="AreaChart"
                :settings="{ packages: ['corechart'], language: 'de' }"
                :data="vaccinations"
                :options="chartOptions3"
                @ready="onChartReady"
              />
              <div class="date left">{{ vaccinations.slice(1)[0][0] }} </div>
              <div class="date right">{{ vaccinations.slice(-1)[0][0] }} </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <p class="footnote">Alle Zahlen beziehen sich auf Deutschland.<br>Zuletzt aktualisiert am {{ getLatest() }}</p> -->
    
  </div>
</template>

<script>
// import LineChart from '/Users/j.giesel/vsts/FAZ Vue Chart Library/src/components/LineChart.vue'
// import ChoroplethMap from '/Users/j.giesel/vsts/FAZ Vue Chart Library/src/components/ChoroplethMap.vue'
import LineChart from './components/LineChart.vue'
import ChoroplethMap from './components/ChoroplethMap.vue'

// import landkreiseMap from './assets/maps/wahlkreise2021.json' 
// import landkreiseMap from './assets/maps/RKI_Corona_Landkreise.json'
import landkreiseMap from './assets/maps/lk.json'
import bundeslaenderMap from './assets/maps/bl.json'
import bundeslaenderMap2 from './assets/maps/bl_.json'

import Multiselect from 'vue-multiselect'
// import debounce from 'debounce'

import * as d3 from 'd3'
d3.formatDefaultLocale({
  'decimal': ',',
  'thousands': '.',
  'grouping': [3],
  'currency': ['', '€'],
  'dateTime': '%a %b %e %X %Y',
  'date': '%d.%m.%Y',
  'time': '%H:%M:%S',
  'periods': ['AM', 'PM'],
  'days': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  'shortDays': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  'shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
})

export default {
  name: 'faz-corona-dashboard',
  components: {
    LineChart,
    ChoroplethMap,
    Multiselect
  },
  data () {
    return {
      colors: [['#fff978','#c50000'], ['#b9fff1','#003384'], ['#ffc7c7','#8a0024'], ['#bcf688','#038b38']],
      isSmall: true,
      landkreiseMap: landkreiseMap,
      blMap: bundeslaenderMap,
      blMap2: bundeslaenderMap2,
      hospitalizations: null,
      vaccinations: null,
      incidence: null,
      deaths: null,
      loading: true,
      accordion: [true, false, false, false],
      selectOptions: null,
      selectedRegion: null,
      showToolbox: false
    }
  },
  mounted () {
    const hospi_url = process.env.NODE_ENV == 'development' ? 
      'data/hospi_widget.json' :
      // 'https://dynamic.faz.net/red/2022/corona-dashboard/data/hospi_widget.json'
      'https://cdn.faz-azure.com/multimediaredaktion/corona/dashboard_hospi.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'
    
    const vaccinations_url = process.env.NODE_ENV == 'development' ? 
      'data/dashboard_vaccs.json' :
      // 'https://dynamic.faz.net/red/2022/corona-dashboard/data/vaccs_widget.json'
      'https://cdn.faz-azure.com/multimediaredaktion/corona/dashboard_vaccs.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'
    
    const incidence_url = process.env.NODE_ENV == 'development' ? 
      'data/inci_widget.json' :
      // 'https://dynamic.faz.net/red/2022/corona-dashboard/data/inci_widget.json'
      'https://cdn.faz-azure.com/multimediaredaktion/corona/dashboard_incidence.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'
    
    const deaths_url = process.env.NODE_ENV == 'development' ? 
      'data/deaths_widget.json' :
      // 'https://dynamic.faz.net/red/2022/corona-dashboard/data/deaths_widget.json'
      'https://cdn.faz-azure.com/multimediaredaktion/corona/dashboard_deaths.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    let fetches = [
      fetch(hospi_url).then(r => r.json()),
      fetch(vaccinations_url).then(r => r.json()),
      fetch(incidence_url).then(r => r.json()),
      fetch(deaths_url).then(r => r.json()),
    ]
    Promise.all(fetches).then((results) => {
      this.hospitalizations = results[0]
      this.vaccinations = results[1]
      this.incidence = results[2]
      this.deaths = results[3]
    })
    this.selectOptions = this.landkreiseMap.features.map( el => {return el.properties} )
    this.loading = false
  },
  updated () {
    this.resize()
  },
  methods: {
    resize () {
      this.isSmall = this.$refs.app.getBoundingClientRect().width < 600
    },
    format (number) {
      return d3.format(",")(number)
    },
    getLatest () {
      let today = new Date()
      return String(today.getDate()).padStart(2, '0') + '.' + String(today.getMonth() + 1).padStart(2, '0') + '.' + today.getFullYear()
    },
    toggleAccordion (index) {
      this.accordion = [false, false, false, false]
      this.accordion[index] = true
    },
    toggleToolbox () {
      this.showToolbox = !this.showToolbox
    }
  },
  watch: {
  },
  computed: {
    selectedBlID: function () {
      if(!this.selectedRegion) {
        return null
      } else {
        return parseInt(this.selectedRegion.BL_ID)
      }
    },
    selectedLkID: function () {
      if(!this.selectedRegion) {
        return null
      } else {
        return parseInt(this.selectedRegion.OBJECTID)
      }
    },
    selectedBL: function () {
      if(!this.selectedRegion) {
        return null
      } else {
        return this.blMap.features.find( bl => parseInt(bl.properties.LAND_NR) == parseInt(this.selectedRegion.BL_ID)).properties.LAND_NAME
      }
      // return 'Schleswig-Holstein'
    },
    incidenceComp: function () {
      if(!this.selectedRegion) {
        return this.incidence.bigNumber
      } else {
        return String(this.incidence.map.find(el => el[0] == this.selectedRegion.OBJECTID)[1]).replace('.',',')
      }
    },
    hospComp: function () {
      if(!this.selectedRegion) {
        return String(this.hospitalizations.bigNumber).replace('.',',')
      } else {
        return String(this.hospitalizations.map.find(el => el[0] == this.selectedRegion.BL_ID)[1]).replace('.',',')
      }
    },
    deathsComp: function () {
      if(!this.selectedRegion) {
        return String(this.deaths.bigNumber).replace('.',',')
      } else {
        return String(this.deaths.map.find(el => el[0] == this.selectedRegion.OBJECTID)[1]).replace('.',',')
      }
    },
    vaccsComp: function () {
      if(!this.selectedRegion) {
        return this.format(this.vaccinations.bigNumber)
      } else {
        let bl = this.vaccinations.map.find(el => parseInt(el[0]) == parseInt(this.selectedRegion.BL_ID))
        return this.format(bl[3])
      }
    }
  }
}
</script>

<!--style scoped src="./assets/foundation.css">
</style-->

<style scoped lang="scss">
// @import './assets/foundation.css';
// @import './assets/reset.scss';
@import './assets/vue-multiselect.min.css';
@import './assets/style.scss';
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

div.google-visualization-tooltip {
  border: none !important;
  padding: 4px 10px !important;
  position: absolute !important;
  color: #ffffff !important;
  font-size: 14px !important;
  line-height: 1.3 !important;
  background: #363636 !important;
  border-radius: 2px !important;
  pointer-events: none !important;
  -webkit-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  -moz-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;

  ul {
    margin: 0 !important;
    padding: 0 !important;

    li {
      margin: 0 !important;
      padding: 0 !important;

      span {
        margin: 0 !important;
        padding: 0 !important;
        color: #fff !important;
        line-height: 1.5;
      }
    }
  }
}
.ctn-PlaceholderContent {
    overflow: visible;
}

// .multiselect {
//   border: 1px solid #ddd !important;
//   border-radius: 4px !important;
// }

// .multiselect__single {
//   color: #999;
// }

.multiselect__tags {
  // border-color: #ddd;
  padding: 8px 40px 0 15px;
  background: #fff;
  line-height: 1.2;
}

.multiselect__select {
  background-image: url("./assets/icons/suche-19-x-20.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 50%;
  opacity: .5;
}
.multiselect__select:before {
  display: none;
}
.multiselect--active .multiselect__select {
  transform: none;
  opacity: 0;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px;
  background: #fff;
}
</style>